import "./common";
import "bootstrap/js/dist/carousel"

const faqs = document.querySelectorAll('.faq-title').forEach(function(element) {
    element.addEventListener('click', function (e) {
        const content = this.nextElementSibling;
        content.style.display = 'block';
    });
});

const mobileMenu = document.querySelector('#mobile-menu');
const toggleMenu = document.querySelector('#mobile-toggle');
mobileMenu.addEventListener('click', function (e) {
    toggleMenu.classList.toggle("show");
});

const togglePlus = document.querySelectorAll('.toggle .plus').forEach(function (element) {
    element.addEventListener('click', function (e) {
        const subMenu = this.nextElementSibling;
        subMenu.classList.toggle("show");
    })
});




